import showdown from 'showdown';

const converter = new showdown.Converter({
  // omitExtraWLInCodeBlocks: false,
  // simpleLineBreaks: true,
  backslashEscapesHTMLTags: false,
  noHeaderId: true,
});

converter.makeMarkdownOriginal = converter.makeMarkdown;

const INLINE_TAGS = 'i|em|b|strong|u|strike|sub|sup|a';
const reSpacesBefore = new RegExp(`(\\s+)</(${INLINE_TAGS})>`, 'gi');
const reSpacesAfter = new RegExp(`<(${INLINE_TAGS})([^>]*)>(\\s+)`, 'gi');
const reNeighbours = new RegExp(`</(${INLINE_TAGS})>(\\s*)<(${INLINE_TAGS})([^>]*)>`, 'gi');

converter.makeMarkdown = rawHtml => {
  let retVal = rawHtml;
  // remove &nbsp;
  retVal = retVal.replace(/&nbsp;/gi, ' ');
  /*
  * fix broken transform "html -> md -> html" for spaces around (multiplied) inline tags content:
  * `<i>something </i>words` -> `*something *words` -> `*something *words`
  * `<b><i>something </i></b>words` -> `***something ***words` -> `***something ***words`
  * `<i> something</i> words` -> `* something* words` -> `* something* words`
  * `<b><i> something</i></b> words` -> `*** something*** words` -> `*** something*** words`
  */
  while (reSpacesBefore.test(retVal)) {
    retVal = retVal.replace(reSpacesBefore, '</$2>$1');
  }
  while (reSpacesAfter.test(retVal)) {
    retVal = retVal.replace(reSpacesAfter, '$3<$1$2>');
  }
  // fix `<b>something</b> <i>word</i>` -> `**something***word*` by adding placeholder
  while (reNeighbours.test(retVal)) {
    retVal = retVal.replace(reNeighbours, '</$1>$2<span class="fix"></span><$3$4>');
  }
  // normalize whitespaces
  retVal = retVal.replace(/\s+/g, ' ').trim();
  // make md
  retVal = converter.makeMarkdownOriginal(retVal);
  // remove fix placeholder and replace eol's to space (showdown append 2 `eol` after `</span>`)
  retVal = retVal.replace(/<span class="fix"><\/span>([\n]*)/gi, (str, eol) => (eol ? ' ' : ''));
  // remove unnecessary <span> tags (and normalize eol's after it)
  retVal = retVal.replace(/<\/?span[^>]*>([\n]*)/gi, (str, eol) => (eol ? ' ' : ''));
  // normalize spaces
  retVal = retVal.replace(/[ ]+/g, ' ').trim();
  // normalize line breaks
  retVal = retVal.replace(/<br ?\/?>/gi, '\n').trim();
  return retVal;
};

export default converter;
